import {Spin} from 'antd';

interface LoaderProps {
	size?: 'large' | 'default' | 'small' | null;
	tip?: string | null;
}

const Loading = ({size, tip}: LoaderProps) => {
	return (
		<div
			style={{
				position: 'relative',
				alignSelf: 'center',
				width: '100%',
				height: '100%',
				minHeight: '',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center'
			}}>
			<Spin size={size ?? 'default'} tip={tip ?? ''} />
		</div>
	);
};

export default Loading;
